import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row gx-2 mb-2" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-warning mb-2 py-2"
}
const _hoisted_6 = {
  key: 1,
  class: "form-group mb-0"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 2,
  class: "form-group mb-0"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "row gx-2" }
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = { class: "form-group mb-2" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "form-group mb-2" }
const _hoisted_15 = { class: "d-block text-black fw-semibold" }
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = { class: "form-group mb-2" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = { class: "form-group mb-2" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "form-group mb-2" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "border border-primary mb-5 mt-3" }
const _hoisted_26 = { class: "row gx-2 d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_27 = { class: "col-md-5" }
const _hoisted_28 = { class: "d-flex float-end" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "card-body p-1" }
const _hoisted_31 = { class: "row gx-1" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "col" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "d-block text-black fw-semibold" }
const _hoisted_36 = {
  key: 0,
  class: "text-muted fw-normal"
}
const _hoisted_37 = { class: "invalid-feedback" }
const _hoisted_38 = {
  key: 0,
  class: "col"
}
const _hoisted_39 = {
  key: 1,
  class: "col"
}
const _hoisted_40 = { class: "mb-1" }
const _hoisted_41 = { class: "table-responsive" }
const _hoisted_42 = { class: "table table-fixed text-nowrap align-middle mb-0 table-bordered" }
const _hoisted_43 = {
  key: 0,
  scope: "col"
}
const _hoisted_44 = { class: "produit-col" }
const _hoisted_45 = { class: "info" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "actions-col pe-0" }
const _hoisted_48 = {
  class: "button-container",
  style: {"white-space":"nowrap"}
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "d-flex align-items-center gap-3 mt-4" }
const _hoisted_52 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddClientModal = _resolveComponent("AddClientModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.addVente,
          "validation-schema": _ctx.venteSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.ouverturesChargees && _ctx.ouvertures.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Aucune caisse ouverte pour ce point de vente. Ouvrez une caisse avant d'enregistrer une vente. "))
                  : (_ctx.ouvertures.length === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Caisse", -1)),
                        _createElementVNode("input", {
                          type: "text",
                          value: _ctx.ouvertures[0].caisse.nom,
                          readonly: "",
                          class: "form-control shadow-none fs-md-15 text-black fw-bold"
                        }, null, 8, _hoisted_7)
                      ]))
                    : (_ctx.ouvertures.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                            _createTextVNode(" Caisse "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ouvertureId) = $event)),
                            class: _normalizeClass(["form-select shadow-none fs-md-15 text-black fw-bold", { 'is-invalid': !_ctx.ouvertureId }])
                          }, [
                            _cache[14] || (_cache[14] = _createElementVNode("option", {
                              value: null,
                              disabled: ""
                            }, "Choisir la caisse de cette vente", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ouvertures, (o) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: o.id,
                                value: o.id
                              }, _toDisplayString(o.caisse.nom) + " (ouverte le " + _toDisplayString(_ctx.formatDateOuverture(o.dateOuverture)) + ") ", 9, _hoisted_9))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.ouvertureId]
                          ]),
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "invalid-feedback" }, "Choisissez la caisse qui encaisse cette vente", -1))
                        ]))
                      : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Date commande", -1)),
                  _createVNode(_component_Field, {
                    name: "dateCommande",
                    readonly: true,
                    value: _ctx.getCurrentDate(),
                    type: "date",
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, [
                    _cache[20] || (_cache[20] = _createTextVNode(" Client ")),
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-danger" }, "*", -1)),
                    (!_ctx.selectedClient)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          style: {"float":"right"},
                          class: "btn btn-success me-3 btn-xs b-r-6",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#AddClientModal",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAbonne && _ctx.toggleAbonne(...args)))
                        }, _cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                          _createTextVNode(" Ajouter un client ")
                        ])))
                      : _createCommentVNode("", true),
                    (_ctx.selectedClient)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          style: {"float":"right"},
                          class: "btn btn-success me-3 btn-xs",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAbonne && _ctx.toggleAbonne(...args)))
                        }, _cache[19] || (_cache[19] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                          _createTextVNode(" Rechercher un client ")
                        ])))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.selectedClient)
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: 0,
                        name: "client",
                        modelValue: _ctx.clientCharger,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.clientCharger) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.clientOptions,
                            searchable: true,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner le client" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_Field, {
                        key: 1,
                        name: "client",
                        modelValue: _ctx.selectedClientId,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedClientId) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, {
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            options: _ctx.clientsOps,
                            placeholder: "Sélectionner un client"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])),
                  _createVNode(_component_ErrorMessage, {
                    name: "client",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Total", -1)),
                  _createElementVNode("input", {
                    type: "text",
                    value: _ctx.totalCommande,
                    readonly: "",
                    class: "form-control shadow-none fs-md-15 text-black fw-bold"
                  }, null, 8, _hoisted_18)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Montant reçu", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "0",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.montantRecuSaisi) = $event)),
                    placeholder: String(_ctx.totalCommande),
                    class: _normalizeClass([_ctx.montantInsuffisant ? 'form-control is-invalid' : 'form-control', "shadow-none fs-md-15 text-black fw-bold"])
                  }, null, 10, _hoisted_21), [
                    [
                      _vModelText,
                      _ctx.montantRecuSaisi,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "invalid-feedback" }, "Inférieur au total", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Reliquat à rendre", -1)),
                  _createElementVNode("input", {
                    type: "text",
                    value: _ctx.reliquat,
                    readonly: "",
                    class: _normalizeClass([_ctx.reliquat > 0 ? 'text-success' : 'text-black', "form-control shadow-none fs-md-15 fw-bold"])
                  }, null, 10, _hoisted_24)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-md-7" }, [
                  _createElementVNode("h4", { class: "fs-6 text-white" }, "Ajouter le produit")
                ], -1)),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                      type: "button",
                      disabled: _ctx.isDisable,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addRowProduit()))
                    }, [
                      _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.enModification ? 'Mettre à jour le produit' : 'Ajouter un produit'), 1)
                    ], 10, _hoisted_29)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Produit", -1)),
                    _createVNode(_component_Multiselect, {
                      options: _ctx.produitOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: _ctx.produit.produit,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.produit.produit) = $event)),
                      placeholder: "Sélectionnez le produit",
                      onSelect: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectProd(_ctx.produit.produit, _ctx.produit)))
                    }, null, 8, ["options", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Quantité", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "0",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.produit.qtite) = $event)),
                      class: _normalizeClass(_ctx.validateRowProduit(_ctx.produit.qtite) ? 'form-control is-invalid' : 'form-control'),
                      placeholder: "Entrer la quantité"
                    }, null, 2), [
                      [
                        _vModelText,
                        _ctx.produit.qtite,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "invalid-feedback" }, "Champ obligatoire", -1))
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, [
                      _cache[31] || (_cache[31] = _createTextVNode(" Prix unitaire ")),
                      (_ctx.produit.prixMin != null || _ctx.produit.prixMax != null)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_36, " (" + _toDisplayString(_ctx.produit.prixMin ?? 0) + " – " + _toDisplayString(_ctx.produit.prixMax ?? '∞') + ") ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "0",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.produit.prix) = $event)),
                      class: _normalizeClass(_ctx.prixInvalide(_ctx.produit) ? 'form-control is-invalid' : 'form-control'),
                      placeholder: "Entrer le prix"
                    }, null, 2), [
                      [
                        _vModelText,
                        _ctx.produit.prix,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.messagePrix(_ctx.produit)), 1)
                  ]),
                  (_ctx.moduleGStockActif)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Magasin", -1)),
                        _createVNode(_component_Multiselect, {
                          options: _ctx.magasin1Options,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: _ctx.produit.magasin,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.produit.magasin) = $event)),
                          placeholder: "",
                          onSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateStockByMagasin(_ctx.produit)))
                        }, null, 8, ["options", "modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.moduleGStockActif)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _cache[33] || (_cache[33] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Stock", -1)),
                        _createElementVNode("p", _hoisted_40, "Physique : " + _toDisplayString(_ctx.produit.stockPhysique || 0), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("table", _hoisted_42, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[34] || (_cache[34] = _createElementVNode("th", {
                      scope: "col",
                      class: "info"
                    }, "Produit", -1)),
                    _cache[35] || (_cache[35] = _createElementVNode("th", { scope: "col" }, "Quantité", -1)),
                    _cache[36] || (_cache[36] = _createElementVNode("th", { scope: "col" }, "Prix unitaire", -1)),
                    (_ctx.moduleGStockActif)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_43, "Magasin"))
                      : _createCommentVNode("", true),
                    _cache[37] || (_cache[37] = _createElementVNode("th", {
                      scope: "col",
                      class: "actions pe-0"
                    }, "ACTIONS", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (prod, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_44, [
                        _createElementVNode("span", _hoisted_45, _toDisplayString(prod.libelleProduit), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(prod.qtite), 1),
                      _createElementVNode("td", null, _toDisplayString(prod.prix), 1),
                      (_ctx.moduleGStockActif)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString(_ctx.getMagasinLabel(prod.magasin)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-warning transition border-0 pb-2 ps-8 pe-8",
                            onClick: ($event: any) => (_ctx.editProduit(index))
                          }, _cache[38] || (_cache[38] = [
                            _createElementVNode("i", { class: "icofont icofont-ui-edit" }, null, -1)
                          ]), 8, _hoisted_49),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                            onClick: ($event: any) => (_ctx.removeRowProduit(index))
                          }, _cache[39] || (_cache[39] = [
                            _createElementVNode("i", { class: "icofont icofont-ui-delete" }, null, -1)
                          ]), 8, _hoisted_50)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-success px-4",
                disabled: _ctx.isSaving || _ctx.produits.length === 0 || _ctx.montantInsuffisant || !_ctx.ouvertureId
              }, _cache[40] || (_cache[40] = [
                _createElementVNode("i", { class: "fa fa-save me-2" }, null, -1),
                _createTextVNode(" Enregistrer ")
              ]), 8, _hoisted_52),
              _createVNode(_component_router_link, {
                to: "/ventes/liste-ventes",
                class: "btn btn-danger"
              }, {
                default: _withCtx(() => _cache[41] || (_cache[41] = [
                  _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                  _createTextVNode(" Annuler ")
                ])),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createVNode(_component_AddClientModal, { onGetclient: _ctx.getClient }, null, 8, ["onGetclient"])
  ], 64))
}